<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>个人中心</span></div>
			<div class="center flex-between">
				<centerLeft :menu="-6"></centerLeft>
				<div class="center-right">
					<div class="order">
						<div class="order-msg" v-if="info.orderStatus == 0 && info.payType == 2 && info.paymentStatus === -1 && info.paymentRejectReason">
							线下转款审核被驳回，驳回原因:{{info.paymentRejectReason}}
						</div>
						<div class="order-status flex-between flex-center">
							<div class="order-status-icon" v-if="info.orderStatus == 0 && info.payType != 2">
								<img src="@/assets/images/me/info1.png"/>
								<div>等待付款</div>
							</div>
							<div class="order-status-icon" v-if="info.orderStatus == 0 && info.payType == 2 && info.paymentStatus === -1">
								<img src="@/assets/images/me/info1.png"/>
								<div>等待付款</div>
							</div>
							<div class="order-status-icon" v-if="info.orderStatus == 0 && info.payType == 2 && info.paymentStatus === null">
								<img src="@/assets/images/me/info1.png"/>
								<div>付款待确认</div>
							</div>
							<div class="order-status-icon" v-if="info.orderStatus == 0 && info.payType == 2 && info.paymentStatus === 0">
								<img src="@/assets/images/me/info1.png"/>
								<div>付款已确认</div>
							</div>
							<div class="order-status-icon" v-if="info.orderStatus <= 2 && info.orderStatus > 0">
								<img src="@/assets/images/me/info2.png"/>
								<div>待发货</div>
							</div>
							<div class="order-status-icon" v-if="info.orderStatus == 3">
								<img src="@/assets/images/me/info2.png"/>
								<div>等待收货</div>
							</div>
							<div class="order-status-icon" v-if="info.orderStatus == 4">
								<img src="@/assets/images/me/info4.png"/>
								<div>交易完成</div>
							</div>
							<div class="order-status-icon" v-if="info.orderStatus == -1">
								<img src="@/assets/images/me/info5.png"/>
								<div>交易取消</div>
							</div>
							<div class="order-status-icon" v-if="info.orderStatus == -2">
								<img src="@/assets/images/me/info5.png"/>
								<div>交易关闭</div>
							</div>
							
							
							<div class="order-status-num" v-if="info.orderStatus != 0">
								<div class="order-status-num-value">{{info.orderNo}}</div>
								<div class="order-status-num-title">订单编号</div>
							</div>
							<div class="order-status-num" v-if="info.orderStatus != 0" style="margin-right: 40px;">
								<div class="order-status-num-value">{{info.createTime}}</div>
								<div class="order-status-num-title">下单时间</div>
							</div>
							
							
							<div class="order-status-num" v-if="info.orderStatus == 0 && info.payType == 1">
								<div class="order-status-num-value">剩余 <el-statistic :value="new Date(info.expectCancelTime)" format="HH时mm分ss秒" time-indices @finish="getInfo"/></div>
								<div class="order-status-num-title">付款截至</div>
							</div>
							<div class="order-status-num" v-if="info.orderStatus == 0 && info.payType == 2 && info.paymentStatus === -1">
								<div class="order-status-num-value">剩余 <el-statistic :value="new Date(info.expectCancelTime)" format="HH时mm分ss秒" time-indices @finish="getInfo"/></div>
								<div class="order-status-num-title">付款截至</div>
							</div>
							<div class="order-status-num" v-if="info.orderStatus == 0 && info.payType == 2 && info.paymentStatus === null">
								<div class="order-status-num-value">付款待确认</div>
								<div class="order-status-num-title"></div>
							</div>
							
							<div class="address-action" v-if="info.orderStatus == 0">
								<div @click="showChangeAddress">切换地址</div>
								<div @click="addaddress">添加地址</div>
							</div>
						</div>
						
						<div class="forget-step flex-midden" v-if="info.orderStatus > -1">
							<div class="forget-step-active">
								<div class="flex-start flex-center">
									<img src="@/assets/images/dui2.png"/>
									<div>提交订单</div>
								</div>
								<div class="forget-step-time">{{info.createTime}}</div>
							</div>
							<div class="forget-step-dian flex-center flex-midden">
								<span :class="info.orderStatus >= 1?'active':''"></span>
								<span :class="info.orderStatus >= 1?'active':''"></span>
								<span :class="info.orderStatus >= 1?'active':''"></span>
								<span :class="info.orderStatus >= 1?'active':''"></span>
							</div>
							<div :class="info.orderStatus >= 1?'forget-step-active':'forget-step-item'">
								<div class="flex-start flex-center">
									<img v-if="info.orderStatus >= 1" src="@/assets/images/dui2.png"/>
									<div v-else>2</div>
									<div>付款成功</div>
								</div>
								<div class="forget-step-time">{{info.payTime}}</div>
							</div>
							
							<div class="forget-step-dian flex-center flex-midden">
								<span :class="info.orderStatus >= 3?'active':''"></span>
								<span :class="info.orderStatus >= 3?'active':''"></span>
								<span :class="info.orderStatus >= 3?'active':''"></span>
								<span :class="info.orderStatus >= 3?'active':''"></span>
							</div>
							
							<div :class="info.orderStatus >= 3?'forget-step-active':'forget-step-item'">
								<div class="flex-start flex-center">
									<img v-if="info.orderStatus >= 3" src="@/assets/images/dui2.png"/>
									<div v-else>3</div>
									<div>商品出库</div>
								</div>
								<div class="forget-step-time">{{info.deliveryTime}}</div>
							</div>
							
							
							<div class="forget-step-dian flex-center flex-midden">
								<span :class="info.orderStatus >= 3?'active':''"></span>
								<span :class="info.orderStatus >= 3?'active':''"></span>
								<span :class="info.orderStatus >= 3?'active':''"></span>
								<span :class="info.orderStatus >= 3?'active':''"></span>
							</div>
							
							<div :class="info.orderStatus >= 3?'forget-step-active':'forget-step-item'">
								<div class="flex-start flex-center">
									<img v-if="info.orderStatus >= 3" src="@/assets/images/dui2.png"/>
									<div v-else>4</div>
									<div>等待收货</div>
								</div>
								<div class="forget-step-time">{{info.deliveryTime}}</div>
							</div>
							
							
							
							<div class="forget-step-dian flex-center flex-midden">
								<span :class="info.orderStatus >= 4?'active':''"></span>
								<span :class="info.orderStatus >= 4?'active':''"></span>
								<span :class="info.orderStatus >= 4?'active':''"></span>
								<span :class="info.orderStatus >= 4?'active':''"></span>
							</div>
							
							<div :class="info.orderStatus >= 4?'forget-step-active':'forget-step-item'">
								<div class="flex-start flex-center">
									<img v-if="info.orderStatus >= 4" src="@/assets/images/dui2.png"/>
									<div v-else>4</div>
									<div>交易完成</div>
								</div>
								<div class="forget-step-time">{{info.receiveTime}}</div>
							</div>
							
							
						</div>
						
						<div v-if="info.expressList != null && info.expressList.length > 0" class="express">
							<div v-for="item in info.expressList"><span>物流单号：</span>{{item.expressNumber}}</div>
						</div>

						<div class="order-title" v-if="info.remark">订单备注</div>
						<div class="address flex-between flex-center flex-wrap" v-if="info.remark" style="padding: 0px;">{{info.remark}}</div>
						
						
						
						<div class="order-title" v-if="info.orderFile.length > 0">相关文件</div>
						<div class="address flex-between flex-center flex-wrap" v-if="info.orderFile.length > 0" style="padding: 0px;">
							<showBoth :list="info.orderFile"></showBoth>
						</div>
						
						
						<div class="order-title" v-if="info.paymentImage.length > 0">线下转款截图</div>
						<div class="address flex-between flex-center flex-wrap" v-if="info.paymentImage.length > 0" style="padding: 0px;">
							<showImage :list="info.paymentImage"></showImage>
						</div>
						
						<div class="order-title">商品信息</div>
						
						<div class="ordergoods-table" v-if="info.goodsList.length > 0">
							<div class="ordergoods-table-title flex-center flex-between">
								<div class="ordergoods-table-title-title">商品信息</div>
								<div class="ordergoods-table-title-price">单价</div>
								<div class="ordergoods-table-title-price">数量</div>
								<div class="ordergoods-table-title-price">小计</div>
								<div class="ordergoods-table-title-price">实付</div>
							</div>
							<div class="ordergoods-table-body">
								<div v-for="item in info.goodsList" :key="item.id" class="ordergoods-table-item flex-between flex-center">
									
									<div class="ordergoods-table-item-goods flex-start flex-center" @click="toInfo(item.goodsId)">
										<img class="ordergoods-table-item-goods-image" :src="item.goodsSpecImage" mode="aspectFill"></img>
										<div class="ordergoods-table-item-goods-text">
											<div>{{item.goodsName}}</div>
											<div>{{item.goodsSpecName}}</div>
										</div>
										<div class="ordergoods-table-item-price">￥{{item.unitPrice}}</div>
										<div class="ordergoods-table-item-price">{{item.goodsNum}}</div> 
										<div class="ordergoods-table-item-value">￥{{item.totalPrice}}</div> 
										<div class="ordergoods-table-item-value">￥{{item.totalPrice}}</div> 
									</div>
								</div>
							</div>
						</div>
						
						<div class="order-title">收货信息</div>
						<div class="address flex-between flex-center">
							<div class="address-info">
								<div><span>收货人：</span>{{info.receiveName}}</div>
								<div><span>联系方式：</span>{{info.phone}}</div>
								<div><span>收货地址：</span>{{info.province}}{{info.city}}{{info.county}}{{info.detailAddress}}</div>
							</div>
						</div>
						
						
						<div class="order-title">订单详情</div>
						<div class="address flex-between flex-center">
							<div class="address-info">
								<div><span>订单编号：</span>{{info.orderNo}}</div>
								<div><span>下单时间：</span>{{info.createTime}}</div>
							</div>
						</div>
						
						
						<template v-if="info.transferImage.length > 0">
							<div class="order-title">付款凭证</div>
							<div class="address flex-between flex-center" style="padding: 0px;">
								<showImage :list="info.transferImage"></showImage>
							</div>
						</template>
						
						
						<div class="order-title">金额明细</div>
						
						<div class="order-result flex-end">
							<div class="order-result-item">
								<div class="order-result-item-text">
									商品件数：<span>{{info.goodsNum}}件</span>
								</div>
								<div class="order-result-item-text">
									商品总价：<span>￥{{info.totalPrice}}</span>
								</div>
								<div class="order-result-item-text">
									优惠券抵扣：<span>￥{{info.couponPrice}}</span>
								</div>
								<div class="order-result-item-text">
									积分抵扣：<span>￥{{info.integralPrice}}</span>
								</div>
								
								<div class="order-result-item-text">
									运费：<span>￥{{info.freightPrice}}</span>
								</div>
								<div class="order-result-item-text">
									应付总额：<span>￥{{info.meetPrice}}</span>
								</div>
								
								<el-button class="order-result-item-button" :loading="false" v-if="info.orderStatus == 0 && info.payType != 2" @click="toPay()">去支付</el-button>
								<el-button class="order-result-item-button" :loading="false" v-if="info.orderStatus == 0 && info.payType == 2 && info.paymentStatus == -1" @click="toPay()">去支付</el-button>
								
								<el-button class="order-result-item-button" :loading="false" v-if="info.orderStatus == 3" @click="changeStatusValue(id, 4)">确认收货</el-button>
								<el-button class="order-result-item-button" v-if="info.invoiceStatus == 0" @click="showPdf(info.invoiceFile)" :loading="false">查看发票</el-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	  </div>
	  
	  <addressForm ref="addressRef"></addressForm>
	  <addressSelect ref="addressSelectRef" @success="addressSubmit"></addressSelect>
	</div>
</template>

<script>
import centerLeft from '@/components/center-left.vue'
import addressForm from '@/components/addressForm.vue'
import addressSelect from '@/components/addressSelect.vue'
import {orderInfo,updateOrderAddress,updateOrderStatus} from "@/api/user"
import showBoth from '@/components/showBoth.vue';
import showImage from '@/components/showImage.vue';
export default {
	name: 'index',
	components:{
		addressForm,
		addressSelect,
		centerLeft,
		showBoth,
		showImage
	},
	data(){
		return {
			info:{goodsList:[],expressList:[],orderFile:[],paymentImage:[],transferImage:[]},
			id:0,
			show:false
		}
	},
	mounted() {
			if(this.$route.query.id){
				this.id = (this.$route.query.id-20)/23;
			}else{
				this.id = 0;
			}
			this.getInfo();
	},
	methods:{
		getInfo(){
			orderInfo({orderId:this.id}).then(res=>{
				if(res.code == 1000){
					this.info = res.data;
					this.info.paymentImage = res.data.paymentImage?res.data.paymentImage.split(","):[];
					this.info.transferImage = res.data.transferImage?res.data.transferImage.split(","):[];
					this.info.orderFile = res.data.orderFile?JSON.parse(res.data.orderFile):[];
					this.show = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		addressSubmit(e){
			if(e.id != 0){
				updateOrderAddress({addressId:e.id,orderId:this.id}).then(res=>{
				if(res.code == 1000){
					this.getInfo();
				}else{
					return this.$message.error(res.message);
				}
			})
			}
		},
		toInfo(id){
			window.open("/goodsinfo?id="+id);
		},
		addaddress(){
			this.$refs.addressRef.init(0);
		},
		showPdf(url){
			window.open(url);
		},
		//切换地址
		showChangeAddress(){
			this.$refs.addressSelectRef.init({id:0});
		},
		toPay(){
			this.$router.push("/pay?id="+this.id);
		},
		changeStatusValue(id,status){
			this.$alert('确定操作吗？', '提示', {
				confirmButtonText: '确定',
				showCancelButton:true,
				callback: action => {
					if(action  == "confirm"){
						updateOrderStatus({orderId:id,orderStatus:status}).then(res=>{
							if(res.code == 1000){
								this.orderInfo();
								this.$message.success("操作完成");
							}else{
								return this.$message.error(res.message);
							}
						})
					}
				}
			});
		}
	}
}
</script>

<style lang="scss" scoped>
	.address-action{
		padding-right: 20px;
		div{
			width: 152px;
			height: 36px;
			border: 1px solid rgba(7, 11, 19, 0.3);
			font-size: 14px;
			color: #070B13;
			line-height: 36px;
			text-align: center;
			margin: 8px 0px;
			cursor: pointer;
			&:last-of-type{
				color: rgba(233, 26, 18, 1);
			}
		}
	}
	.order-status{
		width: 960px;
		border-radius: 8px;
		background: #F8F8F8;
		padding: 34px 0px;
		.order-status-num{
			flex: 0 0 200px;
			text-align: center;
			.order-status-num-value{
				font-size: 20px;
				font-weight: 500;
				line-height: 40px;
				text-align: center;
				color: #070B13;
			}
			.order-status-num-title{
				font-size: 16px;
				color: #070B13;
				margin-top: 8px;
			}
		}
		.order-status-icon{
			border-right: 1px solid rgba(7, 11, 19, 0.1);
			flex: 0 0 163px;
			text-align: center;
			img{
				width: 56px;
				height: 56px;
			}
			div{
				font-size: 16px;
				line-height: 20px;
				color: #070B13;
				margin-top: 8px;
			}
		}
	}
	.forget-step{
		margin-top:30px;
		.forget-step-dian{
			padding: 0px 15px 26px;
			span{
				width: 4px;
				height: 4px;
				background: #E8E8E8;
				border-radius: 100%;
				display: block;
				margin: 0px 5px;
			}
			.active{
				background: rgba(233, 26, 18, 1);
			}
		}
		.forget-step-active{
			img{
				width: 28px;
				height: 28px;
				margin-right: 12px;
				flex: 0 0 28px;
			}
			div{
				font-size: 16px;
				line-height: 24px;
				color: #1D2129;
			}
			.forget-step-time{
				opacity: 0.6;
				font-size: 12px;
				line-height: 16px;
				color: #070B13;
				margin-top: 10px;
				text-align: center;
				height: 16px;
			}
		}
		.forget-step-item{
			div{
				div{
					&:first-of-type{
						width: 28px;
						height: 28px;
						border-radius: 14px;
						background: #F2F3F5;
						margin-right: 12px;
						flex: 0 0 28px;
						font-size: 16px;
						line-height: 28px;
						color: #4E5969;
						text-align: center;
					}
					&:last-of-type{
						font-size: 16px;
						line-height: 24px;
						color: rgba(78, 89, 105, 1);
					}
				}
			}
			.forget-step-time{
				margin-top: 10px;
				height: 16px;
			}
		}
	}
	
	.ordergoods-table-body{
		padding: 0px;
		.ordergoods-table-item{
			padding-left: 40px;
			padding-right: 40px;
			box-sizing: border-box;
			font-size: 14px;
		}
	}
	::v-deep .el-statistic{
		display: inline;
	}
	::v-deep .el-statistic .con{
		display: inline;
		color: rgba(233, 26, 18, 1);
		span{
			font-size: 18px;
		}
	}
	.order{
		width: 100%;
		background: #FFFFFF;
		box-sizing: border-box;
		.order-title{
			font-size: 16px;
			font-weight: 500;
			color: #070B13;
			line-height: 72px;
		}
		.address{
			border: 1px solid rgba(0, 0, 0, 0.1);
			box-sizing: border-box;
			padding: 20px 60px 20px 30px;
			.address-edit{
				flex: 0 0 100px;
				margin-right: 60px;
				img{
					width: 20px;
					height: 20px;
					flex: 0 0 20px;
					margin-right: 12px;
				}
				div{
					font-size: 16px;
					line-height: 20px;
					color: #070B13;
				}
			}
			.address-action{
				border-left: 1px solid rgba(0, 0, 0, 0.1);
				padding-left: 60px;
				div{
					width: 152px;
					height: 36px;
					border: 1px solid rgba(7, 11, 19, 0.3);
					font-size: 14px;
					color: #070B13;
					line-height: 36px;
					text-align: center;
					margin: 8px 0px;
					cursor: pointer;
					&:last-of-type{
						color: rgba(233, 26, 18, 1);
					}
				}
			}
			.address-info{
				width: 100%;
				div{
					font-size: 16px;
					line-height: 22px;
					color: #070B13;
					padding: 8px 0px;
					span{
						width: 90px;
						font-size: 16px;
						color: rgba(7, 11, 19, 0.6);
						display: inline-block;
					}
				}
			}
		}
	}
	
	.order-result{
		border-top: 1px solid rgba(0, 0, 0, 0.1);
		padding-top: 10px;
		.order-result-item{
			.order-result-item-text{
				font-size: 16px;
				font-weight: 500;
				line-height: 40px;
				color: #070B13;
				width: 280px;
				text-align: right;
				span{
					color: #E91A12;
					width: 170px;
					display: inline-block;
				}
			}
			
			.order-result-item-button{
				width: 240px;
				height: 56px;
				background: #E91A12;
				font-size: 20px;
				font-weight: 500;
				letter-spacing: 0em;
				text-align: center;
				color: #FFFFFF;
				margin: 30px 0px 0px 40px;
				border: 0px;
			}
		}
	}
	.center-right{
		min-height: 920px;
		width: 100%;
		padding:40px;
		box-sizing: border-box;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
	}
	.express{
		width: 100%;
		border-radius: 8px;
		background: #F8F8F8;
		padding: 10px 30px;
		box-sizing: border-box;
		margin-top: 30px;
		div{
			font-size: 16px;
			line-height: 16px;
			color: #070B13;
			padding: 14px 0px;
			span{
				color: rgba(7, 11, 19, 0.6);
			}
		}
	}
	@import url("../assets/user.scss");
	
	@import url("../assets/order.scss");
	.order-msg{
		font-size: 16px;
		color: #E91A12;
		font-weight: bold;
		line-height: 30px;
		text-align: center;
		margin-bottom: 20px;
	}
</style>
